module.exports = __webpack_public_path__ + "assets/8685710560a6a111c8b8ea8f9d4d603f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail.png
// module id = 392
// module chunks = 1